import { type AllowedOfflineFn } from 'ProtectedRoute/ProtectedRoute.types';
import { angularInjectorProvider } from 'Injector';
import type OfflineModeManager from './OfflineModeManager';

export const routeAllowedIfStreamAvailableOffline: AllowedOfflineFn = async ({ params }) => {
    const { streamId } = params as { streamId?: string };
    if (!streamId) return false;

    const offlineModeManager = angularInjectorProvider.get<OfflineModeManager>('offlineModeManager');
    return offlineModeManager.streamIdIsAvailableOffline(streamId);
};
